import React from "react";
import { useParams } from "react-router-dom";
import PublicLayout from "@/components/layout/PublicLayout";
import { SponsorLogoUpload } from "@/components/sponsorship/SponsorLogoUpload";

export default function SponsorLogo() {
  const { token } = useParams();
  return (
    <PublicLayout>
      <section className="bg-[#F1F3F6] min-h-[60vh] py-20">
        <div className="max-w-xl mx-auto px-6 bg-white border border-slate-200 rounded-sm p-10">
          <div className="label-overline text-[#E63946]">CBR Sponsor</div>
          <h1 data-testid="sponsor-logo-title" className="font-display text-3xl uppercase tracking-tight mt-2 text-[#0A192F]">Your Sponsor Logo</h1>
          <SponsorLogoUpload token={token} />
        </div>
      </section>
    </PublicLayout>
  );
}
